import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import { CLASS_TYPE_DISPLAY_NAMES } from "./class.mjs";
import { z as z$1 } from "zod";

// src/models/liveClassAttendance.ts
const liveAttendanceLevelSchema = z$1.enum([
	"brief",
	"engaged",
	"completed"
]);
/**
* Attendance levels:
* - brief: attended but duration < 20% of scheduled class time
* - engaged: duration >= 20% and < 80% of scheduled class time
* - completed: duration >= 80% of scheduled class time
*/
const LIVE_ATTENDANCE_LEVELS = {
	brief: "Brief",
	engaged: "Engaged",
	completed: "Completed"
};
/**
* Calculates attendance level from watched/attended time.
* If scheduled class duration is known, use ratio thresholds.
* Otherwise fall back to absolute duration thresholds.
*/
const calculateAttendanceLevel = (durationSeconds, classDurationMinutes) => {
	if (classDurationMinutes && classDurationMinutes > 0) {
		const ratio = durationSeconds / (classDurationMinutes * 60);
		if (ratio >= .8) return "completed";
		if (ratio >= .2) return "engaged";
		return "brief";
	}
	if (durationSeconds >= 1200) return "completed";
	if (durationSeconds >= 300) return "engaged";
	return "brief";
};
const customerLiveClassAttendanceSchema = z$1.object({
	id: zodFlavorId(),
	/** Zoom join/leave segments minus one (0 = single session). Omitted on older documents. */
	reconnectCount: z$1.optional(z$1.number().int().min(0)),
	customerId: zodFlavorId(),
	classInstanceId: zodFlavorId(),
	classId: zodFlavorId(),
	className: z$1.string(),
	classType: z$1.enum(Object.keys(CLASS_TYPE_DISPLAY_NAMES)),
	instructorName: meta(z$1.string(), { pii: { category: "name" } }),
	classStartTimeUtc: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date()),
	classDurationMinutes: z$1.number(),
	joinTime: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date().nullable().optional()),
	leaveTime: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date().nullable().optional()),
	durationSeconds: z$1.number(),
	attendanceLevel: liveAttendanceLevelSchema,
	createdAt: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date()),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date())
}).refine((data) => data.id === data.classInstanceId, {
	message: "Document ID and classInstanceId must match",
	path: ["id", "classInstanceId"]
});

export { LIVE_ATTENDANCE_LEVELS, calculateAttendanceLevel, customerLiveClassAttendanceSchema, liveAttendanceLevelSchema };
//# sourceMappingURL=liveClassAttendance.mjs.map